(() => {
  const id = 'G-SGYHRWVRVJ';
  let loaded = false;
  window['ga-disable-' + id] = true;
  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
  if (!window.coiConsentDefaultsSet) {
  window.gtag('consent', 'default', {analytics_storage:'denied', ad_storage:'denied', ad_user_data:'denied', ad_personalization:'denied'});
    window.coiConsentDefaultsSet = true;
  }
  function update() {
    const privacy = window.Shopify?.customerPrivacy;
    const allowed = privacy?.analyticsProcessingAllowed?.() === true;
    const marketingAllowed = privacy?.marketingAllowed?.() === true;
    const sharingAllowed = privacy?.saleOfDataAllowed?.() === true;
    const adsAllowed = allowed && marketingAllowed && sharingAllowed;
    window['ga-disable-' + id] = !allowed;
    window.gtag('consent', 'update', {
      analytics_storage: allowed ? 'granted' : 'denied',
      ad_storage: adsAllowed ? 'granted' : 'denied',
      ad_user_data: adsAllowed ? 'granted' : 'denied',
      ad_personalization: 'denied'
    });
    if (!allowed || loaded || window.Shopify?.designMode) return;
    loaded = true;
    window.gtag('js', new Date());
    window.gtag('config', id, {allow_google_signals:false, allow_ad_personalization_signals:false});
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=' + id;
    document.head.append(script);
  }
  document.addEventListener('visitorConsentCollected', update);
  if (window.Shopify?.customerPrivacy) update();
  else window.Shopify?.loadFeatures?.([{name:'consent-tracking-api', version:'0.1'}], error => {if (!error) update();});
})();
